import { buildExecutiveGovernorActivationReport } from "@/governor/activation/ExecutiveGovernorActivationBridge";

export interface CallsGovernorExecutiveBridgeReport {
  governorId: "calls";
  executiveAware: boolean;
  active: boolean;
  maturity: string;
  inventoryStatus: string;
  evidence: string[];
}

export function buildCallsGovernorExecutiveBridgeReport(): CallsGovernorExecutiveBridgeReport {
  const executiveReport = buildExecutiveGovernorActivationReport();

  const calls = executiveReport.supervisedGovernors.find(
    g => g.id === "calls"
  );

  return {
    governorId: "calls",
    executiveAware: Boolean(calls),
    active: Boolean(calls?.active),
    maturity: calls?.maturity ?? "UNMAPPED",
    inventoryStatus: calls?.inventoryStatus ?? "UNMAPPED",
    evidence: [
      calls
        ? "calls-governor-placement-found"
        : "calls-governor-placement-missing",
      ...(calls?.evidence ?? []),
    ],
  };
}

export const CALLS_GOVERNOR_EXECUTIVE_BRIDGE_READY = true;
